import { useEffect } from "react";
import { MapContainer, TileLayer, Marker, useMapEvents, useMap, Circle } from "react-leaflet";
import L from "leaflet";

const pin = (color, label = "") =>
  L.divIcon({
    className: "ukerja-pin",
    html: `<div style="display:flex;flex-direction:column;align-items:center"><div style="background:${color};color:#fff;border:3px solid #fff;box-shadow:0 4px 10px rgba(0,0,0,.3);width:30px;height:30px;border-radius:50% 50% 50% 0;transform:rotate(-45deg);display:grid;place-items:center"><span style="transform:rotate(45deg);font:700 11px 'DM Sans'">${label}</span></div></div>`,
    iconSize: [30, 30],
    iconAnchor: [15, 30],
  });

export const jobPin = pin("#059669", "J");
export const workerPin = pin("#D97706", "W");
export const mePin = pin("#2563EB", "");

const DEFAULT = [-6.2, 106.8166];

function ClickPick({ onPick }) {
  useMapEvents({ click: (e) => onPick({ lat: e.latlng.lat, lng: e.latlng.lng }) });
  return null;
}

function Recenter({ center }) {
  const map = useMap();
  useEffect(() => {
    if (center) map.setView(center, map.getZoom());
  }, [center?.[0], center?.[1]]); // eslint-disable-line react-hooks/exhaustive-deps
  return null;
}

export function MapPicker({ value, onChange, height = 220 }) {
  const center = value ? [value.lat, value.lng] : DEFAULT;
  return (
    <div data-testid="job-location-picker" className="rounded-2xl overflow-hidden border border-slate-200" style={{ height }}>
      <MapContainer center={center} zoom={14} style={{ height: "100%", width: "100%" }}>
        <TileLayer attribution="&copy; OpenStreetMap" url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png" />
        <ClickPick onPick={onChange} />
        <Recenter center={value ? center : null} />
        {value && (
          <Marker position={center} icon={jobPin} draggable
            eventHandlers={{ dragend: (e) => { const p = e.target.getLatLng(); onChange({ lat: p.lat, lng: p.lng }); } }} />
        )}
      </MapContainer>
    </div>
  );
}

export function TrackMap({ job, worker, radiusKm, height = 240, testid = "live-tracking-map" }) {
  const center = worker ? [worker.lat, worker.lng] : [job.lat, job.lng];
  return (
    <div data-testid={testid} className="rounded-2xl overflow-hidden border border-slate-200" style={{ height }}>
      <MapContainer center={center} zoom={13} scrollWheelZoom={false} style={{ height: "100%", width: "100%" }}>
        <TileLayer attribution="&copy; OpenStreetMap" url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png" />
        <Marker position={[job.lat, job.lng]} icon={radiusKm ? mePin : jobPin} />
        {radiusKm && <Circle center={[job.lat, job.lng]} radius={radiusKm * 1000} pathOptions={{ color: "#059669", weight: 1, fillOpacity: 0.05 }} />}
        {worker && <Marker position={[worker.lat, worker.lng]} icon={workerPin} />}
        <Recenter center={center} />
      </MapContainer>
    </div>
  );
}
